module.exports = __webpack_public_path__ + "static/media/xVOLT.8e7513a0.svg";